import { tv } from 'tailwind-variants'

export const scrollableListVariants = tv({
  base: ['flex', 'gap-1', 'snap-x scrollbar-hide overflow-x-auto', 'isolate'],
  variants: {
    snap: {
      none: '',
      mandatory: 'snap-mandatory',
      proximity: 'snap-proximity'
    },
    hideScrollbar: {
      true: 'scrollbar-hide',
      false: ''
    }
  },
  defaultVariants: {
    snap: 'mandatory',
    hideScrollbar: true
  }
})
